<script>
    import { onMount } from "svelte";
    import PatientEncounter from "../../Pages/PatientEncounter/PatientEncounter.svelte";
    import { user } from "../../stores";
    import { checkTokenExpiration } from "../../Utils/utilFunctions.svelte";

    export let params;
    export let tokenRefresh = undefined;

    onMount(async () => {
        tokenRefresh = checkTokenExpiration();
    });
</script>

{#await tokenRefresh then tokenRefreshResult}
    {#if tokenRefreshResult === "valid" || tokenRefreshResult === "refreshed"}
        <div class="flex flex-1 flex-col w-full px-6 py-4 bg-[#EEEEEE]">
            <PatientEncounter {params} />
        </div>
    {/if}
{/await}
